import { Component, OnInit, Input, AfterViewInit, ElementRef } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-date-error',
  templateUrl: './form-date-error.component.html',
  styleUrls: ['./form-date-error.component.scss']
})
export class FormDateErrorComponent implements OnInit, AfterViewInit {

  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() format: string;
  @Input() required = false;
  @Input() interval = false;
  @Input() expired = false;
  @Input() item: string;
  @Input() dateElement: ElementRef;
  @Input() mustBeEmpty: false;
  @Input() onlyIcon = false;

  constructor() { }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  getControl(): AbstractControl {
    return this.form.get(this.controlName);
  }

}
